export type DateSchema = { dateOnly?: string[]; dateTime?: string[] };

export const DATE_SCHEMAS: Record<string, DateSchema> = {
    //-----------------CTEs--------------------//

    harvest: {
        dateOnly: ['harvest_date', 'last_feed'],
        dateTime: ['created_at', 'updated_at'],
    },

    firstLandBase: {
        dateOnly: ['landing_date', 'harvest_start', 'harvest_end'],
        dateTime: ['created_at', 'updated_at'],
    },

    processingLine: {
        dateOnly: ['production_date'], // matches top-level + rows (raw_materials/finished_goods)
        dateTime: [], // add here if you later include created_at/updated_at
    },

    receive: {
        dateOnly: ['receive_date'],
        dateTime: ['created_at', 'updated_at'],
    },

    shipping: {
        dateOnly: ['shipping_date'],
        dateTime: ['created_at', 'updated_at'],
    },
    transfer: {
        dateOnly: ['shipping_date'],
        dateTime: ['created_at', 'updated_at'],
    },

    //-----------------Auxiliary--------------------//
    hatchery: {
        dateOnly: [], // none
        dateTime: ['in_ts', 'out_ts'], // send with offset
    },

    feedMill: {
        dateOnly: [],
        dateTime: ['production_date', 'purchase_date'],
    },

    raceway: {
        dateOnly: [],
        dateTime: ['stock_date', 'last_feed', 'last_treatment'],
    },

    vehicle: {
        dateOnly: [],
        dateTime: ['product_date', 'purchase_date'],
    },

    users: {
        dateOnly: [],
        dateTime: ['registered_at', 'last_login_at'],
    },

    //------------Master------------

    certifications: {
        dateOnly: [],
        dateTime: ['issue_date', 'expire_date'],
    },

    userProfile: {
        dateOnly: [],
        dateTime: ['issue_date', 'expire_date'],
    },

    // Add more feature schemas here...
};

/** Decide which schema to use based on URL and/or body */
export function getSchemaKey(url: string, body?: any): string | null {
    if (body?.event_type === 'FarmHarvest' || /\/harvest(\/|$)/i.test(url))
        return 'harvest';

    //  Detect Land Base by event_type or URL
    if (body?.event_type === 'FirstLandBasedReceiving') return 'firstLandBase';
    if (/(first[- ]?land[- ]?base|land[- ]?base|landing)/i.test(url))
        return 'firstLandBase';

    // detect Processing by event_type or URL
    if (body?.event_type === 'ProcessingLine') return 'processingLine';
    if (/\/processing(\/|$)/i.test(url)) return 'processingLine';

    //  Detect Receive by event_type or URL
    if (body?.event_type === 'Receive' || /\/receive(\/|$)/i.test(url))
        return 'receive';

    //  detect Shipping by explicit event_type or URL
    if (body?.event_type === 'Shipping' || /\/shipping(\/|$)/i.test(url))
        return 'shipping';

    //  detect Transfer by explicit event_type or URL
    if (body?.event_type === 'Transfer' || /\/transfer(\/|$)/i.test(url))
        return 'transfer';

    // Hatchery by URL (and optional event_type if you ever add one)
    if (/\/auxiliary\/hatchery(\/|$)/i.test(url)) return 'hatchery';

    // Feedmill by URL
    if (/\/auxiliary\/feedmill(\/|$)/i.test(url)) return 'feedMill';

    // Raceways by URL
    if (/\/auxiliary\/raceway(\/|$)/i.test(url)) return 'raceway';

    // Vehicles by URL
    if (/\/auxiliary\/vehicle(\/|$)/i.test(url)) return 'vehicle';

    if (/\/settings\/users(\/|$)/i.test(url)) return 'users';

    if (/\/settings\/certifications(\/|$)/i.test(url)) return 'certifications';

    if (/\/user_profile(\/|$)/i.test(url)) return 'userProfile';

    return null;
}
